import type { StateCreator } from 'zustand';
import type { CampaignID } from '@energy-retailer/constants';

export type PromotionSliceState = {
  promotionId: CampaignID;
};

export type PromotionSliceActions = {
  setPromotionId: (id: CampaignID) => void;
  resetPromotion: () => void;
};

const initialState: PromotionSliceState = {
  promotionId: null,
};

export const PromotionSlice: StateCreator<
  PromotionSliceActions & PromotionSliceState,
  [['zustand/devtools', never]],
  [],
  PromotionSliceActions & PromotionSliceState
> = (set) => ({
  ...initialState,
  setPromotionId: (promotionId: CampaignID) => {
    set({ promotionId }, undefined, 'PromotionSlice/setPromotionId');
  },
  resetPromotion: () => {
    set(initialState, undefined, 'PromotionSlice/resetPromotion');
  },
});
